export const ADDITIONAL_SERVICE_SUCCESS = 'ADDITIONAL_SERVICE_SUCCESS'
export const ADDITIONAL_SERVICE_FAILURE = 'ADDITIONAL_SERVICE_FAILURE'

export const additionalServiceData = (service) =>{
    return (dispatch, getState) => {
        dispatch({ type: ADDITIONAL_SERVICE_SUCCESS,service });
    }
}